/**
 * The public subset of a creator's profile — pure, and deliberately in its own
 * module with NO imports.
 *
 * It used to live in mission.ts, whose import graph reaches firebase/config,
 * which calls getAuth(app) at module load. That needs a real API key, so the
 * unit test passed locally (.env.local supplies one) and took CI down with
 * "auth/invalid-api-key". Testable logic must not drag the app graph in behind it.
 */

/**
 * Fields the public missionpages doc is still MISSING, taken from users/{uid}.
 *
 * Fill-only by design: a creator may have edited their fund page title to
 * something other than their display name, and publishing must never overwrite
 * that. Only the fields listed here are ever copied — email and the rest of the
 * user doc stay private.
 */
export function publicProfileUpdates(
  user: Record<string, any>,
  current: Record<string, any>
): Record<string, string> {
  const out: Record<string, string> = {};
  const has = (v: unknown) => typeof v === 'string' && v.trim() !== '';
  const fill = (to: string, v: unknown) => {
    if (has(v) && !has(current?.[to])) out[to] = v as string;
  };
  fill('title', user?.displayName || [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim());
  fill('photoURL', user?.photoURL);
  fill('headerImage', user?.coverImage);
  fill('description', user?.biography);
  fill('donationImpact', user?.donationImpact);
  return out;
}
